type TriangleRightProps = {
  className?: string;
};

const TriangleRight = ({ className }: TriangleRightProps) => (
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      id="Vector 2615"
      d="M1 1L9 9L1 17"
      stroke="black"
      strokeLinecap="round"
    />
  </svg>
);

export default TriangleRight;
